import _axios from 'axios';

const prefix = '/api';

_axios.defaults.headers['Content-type'] = 'application/x-www-form-urlencoded';
_axios.defaults.headers.post['Content-type'] =
  'application/x-www-form-urlencoded';

const dataUtils = {
  async postData(url, body, headers) {
    if (!url.includes('http')) {
      url = prefix + url;
    }

    return await _axios.post(url, body, { headers });
  },
  async putData(url, body, headers) {
    return await _axios.put(prefix + url, body, { headers });
  },
  async patchData(url, body, headers) {
    return await _axios.patch(prefix + url, body, { headers });
  },
  async getData(url, params, headers, responseType) {
    if (!url.includes('http') && !url.includes('outApi')) {
      url = prefix + url;
    }

    return await _axios.get(url, { params, headers, ...responseType });
  },
  async deleteData(url, body, headers) {
    return await _axios.delete(prefix + url, body, { headers });
  }
};

export const customAxios = _axios;

export default dataUtils;
